<div class="d-flex w-100" [style.opacity]="disabled() ? 0.5 : 1">
    <div class="d-flex w-40">
        <telxl-avatar
            [presence]="item().presence?.class"
            [variant]="source()"
            [name]="item().name"
        />
        <div class="user d-flex justify-content-around flex-column pe-2">
            <div class="font-sm weight-medium truncate">
                {{ item().name }}
            </div>
            <div class="font-xs truncate">
                <span class="me-1">Status:</span>
                <span class="weight-medium">
                    {{ item().presence?.label }}
                </span>
            </div>
        </div>
    </div>
    <div class="d-flex w-30 flex-column line-height justify-content-around">
        <div>
            <span class="me-1 font-xs text-details">Job Title:</span>
            <span class="font-sm">
                {{ item().jobTitle }}
            </span>
        </div>
        <div>
            <span class="me-1 font-xs text-details">Department:</span>
            <span class="font-sm">
                {{ item().department }}
            </span>
        </div>
    </div>
    <div class="d-flex w-30 flex-column line-height justify-content-around">
        @if (item().businessNumber) {
            <div>
                <span class="me-1 font-xs text-details">Business:</span>
                <span class="font-sm expand-button">
                    <a
                        href="#"
                        (click)="action('business'); $event.preventDefault()"
                    >
                        {{ item().businessNumber }}
                    </a>
                </span>
            </div>
        }
        @if (item().mobileNumber) {
            <div>
                <span class="me-1 font-xs text-details">Mobile:</span>
                <span class="font-sm expand-button">
                    <a
                        href="#"
                        (click)="action('mobile'); $event.preventDefault()"
                    >
                        {{ item().mobileNumber }}
                    </a>
                </span>
            </div>
        }
    </div>
</div>
